import { useEffect, useState, useCallback } from 'react';
import { getDashboardAnalyticsV2, getUsersLight } from 'interfaces/user';
import { useNavigate } from 'react-router-dom';
import ChartBar3Period from './components/ChartBar3Period';
import Scatter from './components/Scatter';
import ListMargin from './components/ListMargin';
import GoBack from 'components/actions/GoBack';

const DashboardV2 = () => {
    const navigate = useNavigate();
    const [data, setData] = useState<any>(null);
    const [users, setUsers] = useState<any[]>([]);
    const [assignedTo, setAssignedTo] = useState<string>('');

    // Permission check
    const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
    const ownerId = localStorage.getItem('ownerId');
    const hasFullPermission = permissions.includes('all') || permissions.includes('show:number-dashboard');
    const isRestrictedUser = ownerId && !hasFullPermission;

    // Block access for restricted users
    useEffect(() => {
        if (isRestrictedUser) {
            console.warn('⛔ Accès refusé au Dashboard V2 - utilisateur restreint');
            navigate('/dashboard');
        }
    }, [isRestrictedUser, navigate]);

    const initDashboardData = useCallback(async (assigned?: string) => {
        const res: any = await getDashboardAnalyticsV2(assigned ? { assignedTo: assigned } : undefined);
        if (!res) return;
        if (res.error) {

            console.error('Dashboard fetch error', res.error);
          return;
        }
        setData(res.data); 
      }, []);
      

    useEffect(() => {
        initDashboardData();
        (async () => {
                 const u = await getUsersLight();
                 if (u) setUsers(u);
               })();
    }, [initDashboardData]);

    useEffect(() => {
           initDashboardData(assignedTo || undefined);
         }, [assignedTo, initDashboardData]);

    return (
        <div className="flex h-full w-full flex-col gap-[20px] rounded-[20px] xl:flex-row">
            <div className="h-full w-full rounded-[20px]">
                <GoBack />
                <div className="col-span-9 h-full w-full rounded-t-2xl xl:col-span-6">
                <div className="px-5 flex justify-end">
                  <div className="inline-flex items-center gap-2">
                    <label className="text-[11px] text-gray-500">Chargé de compte</label>
                    <div className="relative">
                      <select
                        value={assignedTo}
                        onChange={(e) => setAssignedTo(e.target.value)}
                        className="w-44 sm:w-56 max-w-[220px] rounded-md border border-gray-300 px-2 py-1 h-8 text-xs focus:border-brand-500 outline-none bg-white pr-6"
                        disabled={!users?.length}
                      >
                        <option value="">Tous</option>
                        {users.map((u) => (
                          <option key={u._id} value={u._id} title={u.email || u.fullName}>
                            {u.fullName} {u.email ? `(${u.email})` : ''}
                          </option>
                        ))}
                      </select>
                      {assignedTo && (
                        <button
                          type="button"
                          onClick={() => setAssignedTo('')}
                          className="absolute right-1 top-1.5 p-0.5 text-gray-400 hover:text-gray-600"
                          title="Effacer"
                        >
                          ×
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                    {/* Statistics */}
                    {/* <div className="z-0 col-span-12 grid h-full w-full grid-cols-2 gap-5 md:grid-cols-2 xl:grid-cols-4">
                        <div id="step-one">
                            <MiniStatistics
                                name="CA du jour"
                                value={data ? `${data.todayBenefit} €` : '-'}
                                icon={
                                    <MdOutlineShoppingBasket color="#0260CB" />
                                }
                                iconBg="bg-lightPrimary"
                            />
                        </div>
                        <div>
                            <MiniStatistics
                                name="CA de la période"
                                value={
                                    data ? `${data.benefitPerPeriod} €` : '-'
                                }
                                icon={<MdEuro color="#0260CB" />}
                                iconBg="bg-lightPrimary"
                            />
                        </div>
                        <div>
                            <MiniStatistics
                                name="Volume de la période"
                                value={
                                    data ? `${data.volumePerPeriod} Kg` : '-'
                                }
                                icon={<TbMoneybag color="#0260CB" />}
                                iconBg="bg-lightPrimary"
                            />
                        </div>
                        <div>
                            <MiniStatistics
                                name="Commandes / période"
                                value={
                                    data ? `${data.totalOrdersPerPeriod}` : '-'
                                }
                                icon={<TbPigMoney color="#0260CB" />}
                                iconBg="bg-lightPrimary"
                            />
                        </div>
                    </div> */}
                    {/* Main data */}
                    <div className="mt-5 grid w-full grid-cols-8 gap-5">
                        <div className="col-span-12">
                            <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
                                <div className="col-span-2">
                                    <ChartBar3Period
                                        title={"Chiffre d'affaires"}
                                        data={data?.monthlyRevenuePerYear}
                                        calculateCumulativeSum={true}
                                        showCurrency={true}
                                    />
                                </div>
                                <div className="col-span-2">
                                    <ChartBar3Period
                                        title={'Nouveaux clients'}
                                        data={data?.last12MonthsNewCustomers}
                                        calculateCumulativeSum={true}
                                        showCurrency={false}
                                    />
                                </div>
                                <div className="col-span-2">
                                    <ChartBar3Period
                                        title={'Nouveaux prospects'}
                                        data={data?.last12MonthsProspects}
                                        calculateCumulativeSum={true}
                                        showCurrency={false}
                                    />
                                </div>
                                <div className="col-span-2">
                                    <ChartBar3Period
                                        title={'Panier moyen'}
                                        data={
                                            data?.last12MonthsAverageBasket
                                                ?.data
                                        }
                                        calculateCumulativeSum={false}
                                        showCurrency={true}
                                    />
                                </div>
                                {/* <div className="col-span-2">
                                    <ChartBar3Period
                                        title={'Conversion prospects/clients'}
                                        data={data?.last12MonthsNewCustomers}
                                    />
                                </div> */}
                                <div className="col-span-4">
                                    <ListMargin
                                        data={data?.allProductsMargin?.filter(
                                            (product: any) =>
                                                product.percentage,
                                        )}
                                    />
                                </div>
                                <div className="col-span-4">
                                    <Scatter
                                        title={'Nuage des marges'}
                                        data={data?.allProductsMargin?.filter(
                                            (product: any) =>
                                                product.margin > 0,
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashboardV2;
